/* Publish by EComposer at 2026-10-19 09:26:50*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-n0hz6kxavv"]=  window.__ectimmers["ecom-n0hz6kxavv"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-n0hz6kxavv"]["ngsatppqm"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-n0hz6kxavv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n0hz6kxavv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u36qqhq073l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u36qqhq073l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-toig0j3b90c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-toig0j3b90c', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 (function () {
  "use strict";

  /* =====================================================
     0) 제품 설정
  ===================================================== */

  var PRODUCT_ID = "B0DZ5T4HV4";
  var PRODUCT_NAME =
    "CHUNGMIJUNG Itchy Scalp Shampoo";

  /*
    동일한 클릭이 짧은 시간 안에 중복 처리되는 것만 방지합니다.
    세션 전체를 1회로 제한하지 않습니다.
  */
  var CLICK_DEBOUNCE_MS = 1500;


  /* =====================================================
     1) Meta 이벤트 공통 데이터
  ===================================================== */

  function createEventData(destinationUrl) {
    var eventData = {
      content_ids: [PRODUCT_ID],
      content_name: PRODUCT_NAME,
      content_type: "product"
    };

    if (destinationUrl) {
      eventData.destination_url = destinationUrl;
    }

    return eventData;
  }


  /* =====================================================
     2) ViewContent

     LP 페이지 실행당 1회 전송합니다.
     새로고침하거나 다시 방문하면 다시 전송됩니다.
  ===================================================== */

  var viewContentSent = false;

  function fireViewContent() {
    if (viewContentSent) {
      return;
    }

    if (typeof window.fbq !== "function") {
      return;
    }

    window.fbq(
      "track",
      "ViewContent",
      createEventData()
    );

    viewContentSent = true;
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      fireViewContent,
      { once: true }
    );
  } else {
    fireViewContent();
  }

  /*
    Meta Pixel이 페이지 코드보다 늦게 준비되는 경우를 대비해
    최대 약 5초 동안 다시 확인합니다.
  */
  var viewContentTries = 0;

  var viewContentTimer =
    window.setInterval(function () {
      viewContentTries++;

      if (viewContentSent) {
        window.clearInterval(viewContentTimer);
        return;
      }

      fireViewContent();

      if (viewContentTries >= 25) {
        window.clearInterval(viewContentTimer);
      }
    }, 200);


  /* =====================================================
     3) 다시마샴푸 Amazon 상품 링크 확인

     다음 조건을 모두 충족해야 합니다.

     1. Amazon.com 도메인
     2. /dp/B0DZ5T4HV4 또는
        /gp/product/B0DZ5T4HV4 상품 경로
  ===================================================== */

  function findAmazonProductAnchor(element) {
    if (
      !element ||
      typeof element.closest !== "function"
    ) {
      return null;
    }

    var anchor = element.closest("a[href]");

    if (!anchor) {
      return null;
    }

    try {
      var parsedUrl = new URL(
        anchor.href,
        window.location.href
      );

      var hostname = parsedUrl.hostname
        .toLowerCase()
        .replace(/\.$/, "");

      var pathname =
        parsedUrl.pathname.toLowerCase();

      var asin =
        PRODUCT_ID.toLowerCase();

      var isAmazonDotCom =
        hostname === "amazon.com" ||
        hostname.endsWith(".amazon.com");

      var isCorrectProductPath =
        pathname.indexOf("/dp/" + asin) !== -1 ||
        pathname.indexOf(
          "/gp/product/" + asin
        ) !== -1;

      return (
        isAmazonDotCom &&
        isCorrectProductPath
      )
        ? anchor
        : null;

    } catch (error) {
      return null;
    }
  }


  /* =====================================================
     4) 동일 클릭 중복 방지

     1.5초 이내의 연속 중복 클릭만 차단합니다.
  ===================================================== */

  var lastClickTime = 0;

  function isDuplicateClick() {
    var currentTime = Date.now();

    if (
      currentTime - lastClickTime <
      CLICK_DEBOUNCE_MS
    ) {
      return true;
    }

    lastClickTime = currentTime;
    return false;
  }


  /* =====================================================
     5) 실제 Amazon 클릭 이벤트

     실제 다시마샴푸 Amazon 링크 클릭 시:
     AmazonClick 사용자 지정 이벤트만 전송합니다.

     AddToCart 이벤트는 전송하지 않습니다.
     Amazon 이동도 차단하거나 지연하지 않습니다.
  ===================================================== */

  document.addEventListener(
    "click",
    function (event) {
      /*
        앞선 코드에서 이미 클릭이 취소된 경우 제외합니다.
      */
      if (event.defaultPrevented) {
        return;
      }

      /*
        일반 좌클릭만 수집합니다.
        우클릭과 가운데 클릭은 제외합니다.
      */
      if (
        typeof event.button === "number" &&
        event.button !== 0
      ) {
        return;
      }

      var amazonAnchor =
        findAmazonProductAnchor(event.target);

      if (!amazonAnchor) {
        return;
      }

      var destinationUrl =
        amazonAnchor.href;

      /*
        Pixel이 준비되지 않았더라도
        Amazon 링크 이동은 그대로 진행됩니다.
      */
      if (typeof window.fbq !== "function") {
        return;
      }

      if (isDuplicateClick()) {
        return;
      }

      /*
        다시마샴푸 Amazon 아웃바운드 클릭 원본 이벤트
      */
      window.fbq(
        "trackCustom",
        "AmazonClick",
        createEventData(destinationUrl)
      );

      /*
        중요:

        AddToCart 없음
        preventDefault 없음
        setTimeout 없음
        window.location.assign 없음

        브라우저 기본 동작으로
        Amazon Attribution URL에 즉시 이동합니다.
      */
    },
    false
  );

})();

} catch(error){console.error(error);}